import { CSSProperties } from "react";
import eth from "../eth-logo.svg";
type Props = {
  className?: string;
  style?: CSSProperties;
};
export const EthLogo = (props: Props) => (
  <img alt="eth logo" src={eth} {...props}></img>
);
